/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4wNiA2LjM1TDAuNSAzLjc5TDAuODUgMy40MzVMMy4wNiA1LjY0TDcuMiAxLjVMNy41NSAxLjg1NUwzLjA2IDYuMzVaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";